<template>
<v-slide-y-transition>
<v-card hover min-height="180" class="flexcard"> 
    <v-layout row align-center class="grow" @click="showForm(product)">
        <!-- <v-flex xs1>
            <v-btn small icon>
                <v-icon color="grey" class="sp-drag">drag_handle</v-icon>
            </v-btn>
        </v-flex> -->
        <v-flex xs3 class="text-xs-center">
            <v-img class="ml-2"
                :src="(product.photo)?uri+product.photo
                :((product.categoria_photo)?uri+product.categoria_photo:'')"
                aspect-ratio="1"
                contain
            >
            </v-img>
        </v-flex>
        <v-flex xs9>
            <v-card-title class="pb-1">
                <span class="subheading">
                    {{ product.productname | truncate(36) }}
                </span>
            </v-card-title>
            <v-card-text class="py-0 caption grey--text text--darken-1">
                {{ product.description | truncate(96) }}
            </v-card-text>
        </v-flex>
    </v-layout>
    <v-card-actions>
        <v-spacer></v-spacer>
        <span class="body-2 secondary--text">{{ price(product.price) }}</span>
        <v-spacer></v-spacer>
        <v-btn small icon @click="duplicate()">
            <v-icon color="grey">file_copy</v-icon>
        </v-btn>
        <v-btn small icon @click="showForm(product)">
            <v-icon color="accent">edit</v-icon>
        </v-btn>
        <v-btn small icon @click="delDialog = true">
            <v-icon color="red">delete</v-icon>
        </v-btn>
    </v-card-actions>
    <!-- modal agendamento ou entrega -->
    <v-dialog v-model="agendamentoDialog" lazy
        max-width="300"
    >
        <v-card>
            <v-card-title primary-title class="title">
                Escolha o tipo de entrega
            </v-card-title>
            <v-card-actions>
                <v-layout row wrap>
                    <v-flex>
                        <v-btn flat color="secondary" @click="newItem(false)">
                            Delivery
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <v-btn flat color="secondary" @click="newItem(true)">
                            Pedido Agendado
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="comboDialog" lazy
        persistent max-width="700" scrollable
    >
        <sp-combo-form :product="product" :toggle="toggleCombo">
        </sp-combo-form>
    </v-dialog>
    <v-dialog v-model="errorModal" max-width="500">
        <v-card>
            <v-card-title class="headline">
                Confirme o endereço
            </v-card-title>
            <v-card-text>
                {{modalText}}
            </v-card-text>
            <v-card-actions>
                <v-layout row wrap>
                    <v-flex>
                        <v-btn flat @click="_=>{$store.commit('TOGGLE_SET_ADDRESS_DIALOG');errorModal=false}">
                            Trocar ou cadastrar endereço
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <v-btn flat @click="errorModal=false">
                            Cancelar
                        </v-btn>
                    </v-flex>
                </v-layout>
                
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" bottom :timeout="3000">
      {{ snackbarTxt }}
      <v-btn
        color="pink"
        flat
        @click="snackbar = false"
        icon
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="delDialog" lazy max-width="450px">
        <v-card>
            <v-card-text class="headline">
                Tem certeza que deseja deletar o produto <b>{{product.productname}}</b>?
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
            <v-btn
                color="black"
                flat
                @click="delDialog = false"
                :disabled="loading"
            >
                Não
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                flat
                @click="removeProduct"
                :loading="loading"
                :disabled="loading"
            >
                Sim
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-card>
</v-slide-y-transition>
</template>

<script>
import {mapGetters} from 'vuex'
import SpComboForm from './SpComboForm'

export default {
    components:{
        SpComboForm,
    },
    props:['product'],
    computed:{
        ...mapGetters([
            'cart',
            'user',
            'productQuant',
            'restaurant'
        ]),
        quant:{
            get(){
                return this.productQuant(this.product._id)
            },
            set(value){
                if(value == ""){
                    value = 0
                }
                
                return this.$store.dispatch('changeQuantProduct',{product:this.product,q:Number.parseInt(value)})
            }
        },
        
    },
    data(){
        return{
            uri:'https://api.socialplace.com.br',
            menu: false,
            comboDialog:false,
            snackbar:false,
            snackbarTxt:'',
            errorModal:false,
            modalText:'',
            agendamentoDialog:false,
            delDialog:false,
            loading:false
        }
    },
    methods:{
        async removeProduct(){
            this.loading = true
            await this.$store.dispatch('deleteProduct',this.product._id)
            this.loading = false
            this.delDialog = false
        },
        toProduct(){
            this.$router.push({name:'Product',params:
            {
                code:this.product.code
            }})
        },
        isAuth(callback){
            if(this.user){
                if(this.$store.state.pendingOrderId){
                    this.snackbarTxt = "Aguarde o seu pedido atual ser concluído."
                    this.snackbar = true
                }else if(!this.$store.state.restaurant.aberto && !this.$store.state.restaurant.delivery_agenda){
                    this.snackbarTxt = "Estamos fechados no momento."
                    this.snackbar = true
                }else{
                    callback()
                }
            }else{
                this.$store.commit('TOGGLE_LOGIN_DIALOG')
            }
        },
        price(v){
            return 'R$' + Number(v).toFixed(2).toString().replace('.',',')
        },
        newItem(agendamento){
            if(!agendamento && !this.$store.state.restaurant.aberto){
                this.snackbarTxt = "Estamos fechados no momento."
                this.snackbar = true
                return
            }
            this.agendamentoDialog = false
            this.$store.commit('SET_AGENDAMENTO',agendamento)
            if(this.product.combolist_id && this.product.combolist_id !=''){
                this.comboDialog = true
            }else{
                this.quant++
            }
        },
        addItem(){            
            if(this.user.address_list.length == 0){
                this.$store.commit('TOGGLE_ADDRESS_DIALOG')
            }else if(this.user.address_list.findIndex(a=>a.address_default==true) == -1){
                this.$store.commit('TOGGLE_SET_ADDRESS_DIALOG')
            }else{
                this.$store.dispatch('checkFreeDistrict').then(res=>{
                    if(res.data.ok){
                        if(this.restaurant.delivery_agenda
                            && !this.restaurant.delivery_agenda_only && !this.cart){
                                this.agendamentoDialog = true
                        }else{                        
                            if((this.restaurant.delivery_agenda
                            && !this.restaurant.aberto) || this.restaurant.delivery_agenda_only)
                                this.$store.commit('SET_AGENDAMENTO',true)
                            if(this.product.combolist_id && this.product.combolist_id !=''){
                                this.comboDialog = true
                            }else{
                                this.quant++
                            }
                        }
                    }else{
                        this.modalText = res.data.error
                        this.errorModal = true
                    }
                }).catch(err=>{
                    this.snackbarTxt = "Ocorreu um erro inesperado."
                    this.snackbar = true
                })
            }
        },
        toggleCombo(){
            this.comboDialog = false
        },
        async duplicate(){
            const data = Object.assign({},this.product)
            delete data._id
            data.productname += " (Cópia)"
            data.code = await this.$store.dispatch('generateCode')
            const product = await this.$store.dispatch("createProduct",data)
            this.showForm(product)
        },
        showForm(product){
            this.$store.commit('FETCH_PRODUCT',product)
            this.$store.commit('TOGGLE_PRODUCT_DIALOG')
        }
    }

}
</script>

<style lang="scss" scoped>
    .flexcard {
        display: flex;
        flex-direction: column;
    }
</style>
